module.exports = __webpack_public_path__ + "img/LUB00146.2588245b.svg";